import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import InputField from '../../../forms/input-field'
import { useDispatch } from 'react-redux';
import AddButton, { DraftButton } from '../../../buttons/button';
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import InnerLayout from '../../../layouts/inner-layout';
import successToast from '../../../helper-components/success-toast';
import errorToast from '../../../helper-components/error-toast';
import { whatsappAddAction, whatsappUpdateAction, whatsappViewAction } from '../../../../redux/actions/settings-action';

const WhatsappConfiguration = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [whatsappConfigData, setWhatsappConfigData] = useState({})

    useEffect(() => {
        dispatch(whatsappViewAction({}, onSuccess, onError));
    }, []);

    const reload = () => {
        dispatch(whatsappViewAction({}, onSuccess, onError))
    }

    const onSuccess = (data) => {
        
        setWhatsappConfigData(data?.data);
    };
    const onError = (data) => {  errorToast(data?.message) };

    const initialValues = {
        id: whatsappConfigData?.id || null,
        api_key: whatsappConfigData?.api_key || "",
        api_url: whatsappConfigData?.api_url || "",
        user_name: whatsappConfigData?.user_name || "",
        password: whatsappConfigData?.password || "",
        number: whatsappConfigData?.number || "",
    }
    const validationSchema = Yup.object().shape({
        api_key: Yup.string().required("Required"),
        api_url: Yup.string().required("Required"),
        user_name: Yup.string().required("Required"),
        password: Yup.string().required("Required"),
        number: Yup.string().required("Required")
    });

    const onSubmit = (values) => {
        
        if (values.id) {
            dispatch(whatsappUpdateAction(values, onCreateSuccess, onError))
        } else {
            dispatch(whatsappAddAction(values, onCreateSuccess, onError))
        }
    }

    const onCreateSuccess = (data) => { successToast(data?.message); reload() };

    return (
        <InnerLayout
            list={true}
            title="Settings"
            module="whatsapp-configuration"
        // permissionFn={permissionFn}
        >
            <div className='pl-4 h-full'>
                <div className='flex justify-between pt-3 text-sml'>
                    <div className=" pb-4 flex items-center gap-2">
                        <button
                            className="flex items-center gap-2"
                            onClick={() => {
                                navigate('/settings')
                            }}
                        >
                            <ChevronLeftIcon className="h-5 w-5 inline-block" />
                            System Settings /
                        </button>
                        <span className="cursor-pointer" >{" " + "Whatsapp Api Config"}</span>
                    </div>
                </div>
                <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, setFieldValue, handleSubmit }) => (
                        <Form className="pl-4 pt-4">
                            <div className=''
                                style={{ height: "78vh" }}
                            >

                                <div className="w-full flex flex-col gap-4">
                                    <div style={{ maxWidth: "35rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="text"
                                            name="api_key"
                                            placeholder="Enter the Api Key"
                                            label="Api Key"
                                            labelWidth="10rem"
                                        />
                                    </div>
                                    <div style={{ maxWidth: "35rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="text"
                                            name="api_url"
                                            placeholder="Enter the api url"
                                            label="Api Url"
                                            labelWidth="10rem"
                                        />
                                    </div>
                                    <div style={{ maxWidth: "35rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="text"
                                            name="user_name"
                                            placeholder="User name"
                                            label="User Name"
                                            labelWidth="10rem"
                                        />
                                    </div>
                                    <div style={{ maxWidth: "35rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="text"
                                            name="password"
                                            placeholder="Enter Password"
                                            label="Password"
                                            labelWidth="10rem"
                                        />
                                    </div>
                                    <div style={{ maxWidth: "35rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="number"
                                            name="number"
                                            placeholder="Enter Business Account Mobile number"
                                            label="Whatsapp Number"
                                            labelWidth="10rem"
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="flex justify-between px-6  bg-white py-4 invoice-bottom-container">
                                <DraftButton
                                    onclkFn={() => navigate(`/settings`)}
                                    text="Cancel"
                                />
                                <AddButton
                                    onclkFn={handleSubmit}
                                    prefixIcon={false}
                                    text="Save"
                                    type="submit"
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </InnerLayout>
    )
}

export default WhatsappConfiguration
